export { App as default } from '@guiker/recommended-listing-main-mfe'
